import { Text } from '@blueprintjs/core'
import { Trans } from 'client/components/Trans/Trans'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC, PropsWithChildren } from 'react'
import cn from 'classnames'

type TProps = {
  i18key: string
  className?: string
} & PropsWithChildren

const FooterColumn: FC<TProps> = ({ i18key, className, children }) => {
  return (
    <div className={cn('flex flex-none', className)}>
      <div className="flex flex-col gap-6">
        <div className="flex h-10 items-center">
          <Text tagName="span" className="text-palette-white font-body---28px uppercase whitespace-pre-wrap">
            <Trans i18nKey={i18key} ns={ClientLocaleNS.Common}></Trans>
          </Text>
        </div>
        <div className="flex w-full flex-col gap-4">{children}</div>
      </div>
    </div>
  )
}

export { FooterColumn }
